import type { BatchStripVariant } from './batchStripTypes.ts'

/**
 * 작업 줄 2행의 모습을 **경로**로 고른다(디자인팀 시안 2026-09-30 §2 「목록 화면(작업·준비·알람)」).
 *
 *   모니터링(`monitoringPath` 와 그 아래) → `full`    공정 칸 셋 + 요약 카드
 *   그 밖(작업 · 이력 · 알람 · 준비 · 관리 …) → `compact` 현재 공정 한 줄 — 표가 한 뼘 위로 올라온다
 *
 * 🔴 **내용이 아니라 경로가 정한다.** 그래야 화면 종류마다 작업 줄 높이가 고정이고(높이 불변 · `docs/shell.md` §3),
 *    같은 화면 안에서 작업 상태가 바뀌어도 높이가 안 흔들린다.
 * ⚠ 셸마다 모니터링 경로가 다르다 — 콘솔은 `PATHS.monitoring`, 태블릿은 `TABLET_PATH.monitoring`. 호출부가 넘긴다.
 * 🔴 **통합 콘솔(`ConsoleLayout`)은 2026-10-03 부터 이 함수를 안 부른다** — 어느 메뉴에서든 `full` 이고(eric 「다른 메뉴에
 *    가도 모니터링에서의 상시창 내용이 보이게 해줘」), 메뉴마다 갈리는 것은 접힘 기본값이다(`useStripFold`). 지금 부르는 셸은
 *    태블릿뿐이다.
 */
export function stripVariantFor(
  pathname: string,
  monitoringPath: string | undefined,
): BatchStripVariant {
  if (monitoringPath === undefined) return 'full'
  return pathname === monitoringPath || pathname.startsWith(`${monitoringPath}/`)
    ? 'full'
    : 'compact'
}
